import ApiService from 'common/service/api';
import { map } from 'rxjs/operators';

export default class WidgetService extends ApiService {
  constructor(config) {
    super(config);

    this.baseURL = `${this.baseURL}/widget`;
  }

  getWidgetDeviceStatusData(dataRange) {
    if (dataRange) {
      return this.fetch(`/status?window=${dataRange}`, {}).pipe(map(ApiService.collectionJson));
    }
    return this.fetch('/status', {}).pipe(map(ApiService.collectionJson),);
  }

  getWidgetDeviceConsumerStatusData() {
  	return this.fetch('/consumerStatus', {}).pipe(map(ApiService.collectionJson),);
  }

  getWidgetDeviceSupplyStatusData() {
  	return this.fetch('/supplyStatus', {}).pipe(map(ApiService.collectionJson),);
  }

  getWidgetDeviceFirmwareData() {
    return this.fetch('/firmware', {}).pipe(map(ApiService.collectionJson),);
  }
}
